import React, { useState } from 'react';


const WiFiConfigModal = ({ device, onClose, onSubmit, isSubmitting }) => {
  const [ssid, setSsid] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!ssid) {
      alert('WiFi Name (SSID) is required.');
      return;
    }
    // Pass the data up to the parent component to handle the API call
    onSubmit({ ssid, password });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Set Wi-Fi for {device.serial_number}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="wifi-ssid">
              Wi-Fi Name (SSID) *
            </label>
            <input
              id="wifi-ssid"
              type="text"
              value={ssid}
              onChange={(e) => setSsid(e.target.value)}
              className="form-input"
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="wifi-pass">
              Password (leave blank for open networks)
            </label>
            <input
              id="wifi-pass"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
            />
          </div>
          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="button button-secondary"
            >
              Cancel
            </button>
             <button type="submit" className="button action-button" disabled={isSubmitting}>
                {isSubmitting ? 'Applying...' : 'Save & Apply'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WiFiConfigModal;